import React, { useState } from 'react';
import { LanguageSelector } from './components/LanguageSelector';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { NewsSection } from './components/NewsSection';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Benefits } from './components/Benefits';
import { Categories } from './components/Categories';
import { OfficialResources } from './components/OfficialResources';
import { HowItWorks } from './components/HowItWorks';
import { QuickServices } from './components/QuickServices';
import { LiveTraffic } from './components/LiveTraffic';
import { EventsCalendar } from './components/EventsCalendar';
import { NextMeeting } from './components/NextMeeting';
import { Participation } from './components/Participation';
import { Impact } from './components/Impact';
import { PhotoGallery } from './components/PhotoGallery';
import { GroupBenefits } from './components/GroupBenefits';
import { FAQ } from './components/FAQ';
import { EmotionalClose } from './components/EmotionalClose';
import { FinalCTA } from './components/FinalCTA';
import { TranslationProvider } from './components/TranslationProvider';
export function App() {
  const [showLanguageSelector, setShowLanguageSelector] = useState(() => {
    // Verificar si el usuario ya seleccionó un idioma en esta sesión
    if (typeof window !== 'undefined') {
      return !sessionStorage.getItem('languageSelected');
    }
    return true;
  });
  return <TranslationProvider data-id="element-0">
      <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-sky selection:text-white" data-id="element-1">
        {showLanguageSelector && <LanguageSelector onSelect={() => setShowLanguageSelector(false)} data-id="element-2" />}
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <NewsSection data-id="element-6" />
          <Problem data-id="element-7" />
          <Solution data-id="element-8" />
          <Benefits data-id="element-9" />
          <Categories data-id="element-10" />
          <OfficialResources data-id="element-11" />
          <HowItWorks data-id="element-12" />
          <QuickServices data-id="element-13" />
          <LiveTraffic data-id="element-14" />
          <EventsCalendar data-id="element-15" />
          <NextMeeting data-id="element-16" />
          <Participation data-id="element-17" />
          <Impact data-id="element-18" />
          <PhotoGallery data-id="element-19" />
          <GroupBenefits data-id="element-20" />
          <FAQ data-id="element-21" />
          <EmotionalClose data-id="element-22" />
          <FinalCTA data-id="element-23" />
        </main>

        <footer className="bg-charcoal-dark text-softblue-dark py-8 text-center text-sm border-t-4 border-sylmar" data-id="element-24">
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-25">
            <img src="https://cdn.magicpatterns.com/uploads/ifXuZUrDS4dUFiWt5hJfva/LOGO_OFICIAL_DE_CONCILIO_DE_SYLMAR_._VERDE.png" alt="Sylmar Neighborhood Council" className="h-10 brightness-200" data-id="element-26" />
          </div>
          <p data-id="element-27">
            © {new Date().getFullYear()} Sylmar Neighborhood Council. Todos los
            derechos reservados.
          </p>
        </footer>
      </div>
    </TranslationProvider>;
}